import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-columns',
  templateUrl: './edit-columns.component.html',
  styleUrls: ['./edit-columns.component.scss']
})
export class EditColumnsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
